import { inRn } from 'lib/helpers/utility';

import Modal from 'components/shared/Modal/Modal';
import LightboxWrapper from 'components/Payments/lightbox/LightboxWrapper';
import { usePaymentContext } from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

import PayFromKioskModal from './PayFromKioskModal/PayFromKioskModal';
import PaymentEntryModal from './PaymentEntryModal/PaymentEntryModal';
import { PAYMENT_ENTRY_KINDS } from './PaymentEntryModal/lib/constants';

const ProcessPayment = ({
  isOpen,
  handleClose,
  invoice,
  amount,
  patientId,
  onSuccess,
  onFail,
  practice,
  SuccessScreen,
  token,
  autoStarted,
  // Check-in opts into the shared card entry: saved cards first, and Elavon collects the card
  // in the same modal. Other surfaces keep manual entry only and Elavon's Converge lightbox.
  useCardEntryModal = false
}) => {
  const { processor, values, terminal, isKiosk, terminalData } = usePaymentContext() || {};

  const isPayroc = processor === 'payroc';

  if (isKiosk && terminalData?.cardPresentTerminal) {
    return (
      <PayFromKioskModal
        isOpen={isOpen}
        handleClose={handleClose}
        patientId={patientId}
        invoice={invoice}
        onSuccess={onSuccess}
        token={token}
        autoStarted={autoStarted}
      />
    );
  }

  if (!terminal?.online) return null;

  if (useCardEntryModal) {
    return (
      <PaymentEntryModal
        isOpen={isOpen}
        handleClose={handleClose}
        patientId={patientId}
        kind={PAYMENT_ENTRY_KINDS.CARD}
      />
    );
  }

  if (isPayroc) {
    return (
      <PaymentEntryModal
        isOpen={isOpen}
        handleClose={handleClose}
        patientId={patientId}
        kind={PAYMENT_ENTRY_KINDS.CARD}
        hideSavedMethods
      />
    );
  }

  return (
    <Modal isOpen={isOpen} handleClose={handleClose} width="full">
      <LightboxWrapper
        f_name={invoice?.patient?.first_name}
        l_name={invoice?.patient?.last_name}
        billingAddress={invoice?.patient?.userAddress}
        amount={inRn(amount ?? values?.amount)}
        patientId={patientId}
        practiceId={practice?.id}
        invoiceId={invoice?.id}
        invoiceToken={values?.invoiceToken}
        tokenOnly={values?.tokenOnly}
        saveCard={values?.saveCard}
        surcharge={inRn(values?.surchargeAmount)}
        SuccessScreen={SuccessScreen}
        onCancel={handleClose}
        onFail={onFail}
        onApproval={onSuccess}
      />
    </Modal>
  );
};

export default ProcessPayment;
